// Intentionally a no-op.
//
// This file used to inject "critical" globalStyles that hard-coded MUI v4
// defaults onto `.MuiButton-root` (text-transform: uppercase, square borders,
// transparent background, 0.875rem font) and onto `.MuiAppBar-root` (fixed
// position, full-viewport width). Both blocks won over the brand `themeNext`
// because emotion's GlobalStyles inject at document level, outside the
// nested ThemeProvider scope — so every brand-purple pill rendered as a
// generic outlined MUI v4 button, and every AppBar overlapped the sidebar.
//
// The component is kept as a no-op so the existing App.js import path stays
// valid. Delete the import + this file together in a later cleanup pass.
const CriticalStyles = () => null;

export default CriticalStyles;
